import React, { useState, useEffect } from "react";
import Input from "../../atoms/Input/Input";
import useRequest from "../../../context/useRequest";
import ConfirmationModal from "../../atoms/ConfirmationModal/ConfirmationModal";
const ForgotPasswordForm = () => {
    const { data: isForgotEmailData, sendRequest } = useRequest();
    const [isForgotEmail, setIsForgotEmail] = useState("");
    const [isFieldErrors, setIsFieldErrors] = useState({})
    const [showModal, setShowModal] = useState(false);
    
    // useEffect(() => {
    //     if (isForgotEmailData && Object.keys(isForgotEmailData).length > 0) {
    //         setIsForgotEmail((prev) => {
    //             return JSON.stringify(prev) === JSON.stringify(isForgotEmailData)
    //                 ? prev
    //                 : { ...prev, ...isForgotEmailData };
    //         });
    //     }
    // }, [isForgotEmailData]);
    useEffect(() => {
        if (isForgotEmailData) {
            setIsForgotEmail(isForgotEmailData.email);
        }
    }, [isForgotEmailData]);
    const forgotHandler = (e) => {
        setIsForgotEmail(e.target.value);
        setIsFieldErrors((prevErrors) => ({
            ...prevErrors,
            email: "",
        }));
    };

    const forgotSubmitHandler = async (e) => {
        e.preventDefault();
        const formForgotPassword = new FormData();
        formForgotPassword.append("email", isForgotEmail);
        // console.log('FormData API email:', isForgotEmail);
        try {
            const response = await sendRequest({
                method: "POST",
                url: "/auth/forgotPassword",
                body:  formForgotPassword,
            });

            if (response) {
                setShowModal(true);
                
                // alert("Form submitted successfully!");
            } else {
                console.log("Condition failed. Response or data is missing.");
            }
        } catch (error) {
            console.error("Error response:", error.response);
            if (error.response?.data?.errors) {
                setIsFieldErrors(error.response.data.errors);
            } else {
                alert("An unexpected error occurred.");
            }
        }
    };
    const handleCloseModal = () => {
        setShowModal(false);
        setIsForgotEmail("");
    };
    return (
        <>
            <form onSubmit={forgotSubmitHandler} className="login-form--item-left-form mt-4" >
                <div className="form-group input-group login-form--item-left-form-input">
                    <Input
                        type="email"
                        name="email"
                        placeholder="Email"
                        value={isForgotEmail || ""}
                        onChange={forgotHandler}
                        className="form-control"
                        label={
                            <span>
                                Email <span style={{ color: "red" }}>*</span>
                            </span>
                        }
                    />
                    {isFieldErrors.email && (
                        <p className="error-message">{isFieldErrors.email}</p>
                    )}
                </div>


                <div className="form-group  login-form--item-left-form-submit">
                    <button type="submit" className="submit">Submit</button>
                </div>
            </form>
            <ConfirmationModal
                show={showModal}
                onClose={handleCloseModal}
                title="Forgot Password"
                body="We have received a request to reset your password."
                className="modalshow"
                actions={[
                    {
                        label: "Submit",
                        onClick: handleCloseModal,
                        className: "btn-custom",
                    },
                ]}
            />
        </>
    )
}
export default ForgotPasswordForm